import useGetWebTippsConfigurationTabComponents from './useGetWebTippsConfigurationTabComponents'

export default useGetWebTippsConfigurationTabComponents
